import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeDeDE from '@angular/common/locales/de';
import localeEnGB from '@angular/common/locales/en-GB';
import localeEsES from '@angular/common/locales/es';
import localeFrFR from '@angular/common/locales/fr';
import localeItIT from '@angular/common/locales/it';
import localeNlBE from '@angular/common/locales/nl-BE';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { CookieConsentComponent } from '@elio/emanager-front/cookie-consent/feature';
import { APP_VERSION, getBrandProvider, getCacheExpirationProvider } from '@elio/emanager-front/shared/app-config';
import { CustomRouteReuseStrategy } from '@elio/emanager-front/shared/tools/router';
import { FILTERABLE_STORE, FILTERS_PERSIST_ID, FilterStore } from '@elio/emanager-front/shared/ui/filters';
import { EmanagerFrontShellModule } from '@elio/emanager-front/shell';
import { CheckForUpdateComponent } from '@elio/shared/check-for-update';
import { ElioLazyLoadedChunkLoaderComponent } from '@elio/shared/ui/lazy-loaded-chunk-loader';
import { ElioToastContainerComponent } from '@elio/shared/ui/toast';
import version from '../../version.json';
import { brand } from '../brands/brand';
import { AppComponent } from './app.component';
import { TranslocoRootModule } from './transloco/translate-http-loader';

registerLocaleData(localeDeDE, 'de-DE');
registerLocaleData(localeEnGB, 'en-GB');
registerLocaleData(localeEsES, 'es-ES');
registerLocaleData(localeFrFR, 'fr-FR');
registerLocaleData(localeItIT, 'it-IT');
registerLocaleData(localeNlBE, 'nl-BE');

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    TranslocoRootModule,
    ReactiveFormsModule,
    EmanagerFrontShellModule,
    ElioToastContainerComponent,
    ElioLazyLoadedChunkLoaderComponent,
    CheckForUpdateComponent,
    CookieConsentComponent,
  ],
  providers: [
    getCacheExpirationProvider(30),
    getBrandProvider(brand),
    {
      provide: APP_VERSION,
      useValue: version.version,
    },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    { provide: FILTERABLE_STORE, useClass: FilterStore },
    {
      provide: FILTERS_PERSIST_ID,
      useValue: 'app',
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
